module.exports = __webpack_public_path__ + "static/media/sala.e66352cd.jpg";